import React, { Component } from 'react';
import { Link } from 'gatsby';
import { Wrapper, HtmlContent, Image } from '..';
import './PackageListItem.scss';

const DETAILS_TAB_TYPE = 'DETAILS_TAB_TYPE';

class PackageListItem extends Component {
  state = {
    activeTab: DETAILS_TAB_TYPE,
  };

  activateTab = (event, activeTab) => {
    event.preventDefault();
    this.setState({ activeTab });
  }

  render() {
    const {
      featuredImage,
      packageType,
      startingPrice,
      details,
      // testimonials,
    } = this.props;
    const {
      activeTab,
    } = this.state;
    return (
      <section className="package-list-item">
        <Wrapper>
          <div className="container">
            <div className="col image-col">
              <div className="image-container">
                <Image image={featuredImage} />
              </div>
            </div>
            <div className="col text-col">
              <h2 className="package-type">{packageType.text}</h2>
              <span className="starting-price">{startingPrice.text}</span>
              <div className="accordion">
                <div className={`accordion-tab details-tab ${activeTab === DETAILS_TAB_TYPE ? 'active' : ''}`}>
                  <button
                    type="button"
                    className="tab-button"
                    onClick={event => this.activateTab(event, DETAILS_TAB_TYPE)}
                    aria-label="Show package details"
                  >
                    <span>Details</span>
                  </button>
                  <div className="content">
                    <HtmlContent content={details.html} />
                  </div>
                </div>
              </div>
              <Link
                to="/contact/"
                className="styled-button styled-button-full-width enquire-button"
                aria-label="Navigate to contact page"
              >
                <span>Enquire</span>
              </Link>
            </div>
          </div>
        </Wrapper>
      </section>
    );
  }
}

export default PackageListItem;
